import type { DelegateTraceEntry } from '../../../data/projects/lib/computer-use-trace.types';

export type ComputerUsePlanPhase = 'awaiting' | 'running' | 'stopped' | 'done';

export const formatComputerUseElapsed = (totalSeconds: number): string => {
  const safe = Math.max(Math.floor(totalSeconds), 0);
  if (safe < 60) return `${safe}s`;
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  return seconds === 0 ? `${minutes}m` : `${minutes}m ${seconds}s`;
};

// Drop lifecycle and success duplicates, but keep failures visible.
const ACTIVITY_KINDS: ReadonlySet<DelegateTraceEntry['kind']> = new Set([
  'tool_call',
  'step_progress',
  'planner_text',
  'executor_text',
]);

const isComputerUseActivityEntry = (entry: DelegateTraceEntry): boolean =>
  !!entry.isError || ACTIVITY_KINDS.has(entry.kind);

export const selectComputerUseActivityEntries = (
  trace: readonly DelegateTraceEntry[] | undefined
): DelegateTraceEntry[] => (trace ?? []).filter(isComputerUseActivityEntry);

export const hasComputerUseActivityEntries = (
  trace: readonly DelegateTraceEntry[] | undefined
): boolean => (trace ?? []).some(isComputerUseActivityEntry);
